import { createContext } from 'react';
import { Voni } from '@voniai/nodejs';

export interface VoniContextType {
  client: Voni;
}

export const VoniContext = createContext<VoniContextType | undefined>(undefined);
